








































import { Component, Vue, Prop } from 'vue-property-decorator'
import dayPeriodsList from '@/store/data/dayPeriodOptions'
import IDayRangeToggleOptions from '@/store/interface/IDayRangeToggleOptions'

/**
 * DayRangeToggler - component responsible for rendering day range button toggle
 * with appropriate icons above text.
 */
@Component({
	name: 'DayRangeToggler'
})
export default class DayRangeToggler extends Vue {
	@Prop({ default: '' })
	private chosenOption!: string | boolean
	private options: IDayRangeToggleOptions[] = dayPeriodsList

	// Emits value to parent component
	private onInput (val: string): void {
		this.$emit('toggleChange', val)
	}
}
